import { Skeleton } from '@/components/ui/Skeleton.tsx';

/** Karta z trzema wierszami, wyszukiwarka z listą przelewów i pole kwoty. */
const MatchExpenseModalSkeleton = () => (
  <>
    <div className="space-y-2 rounded-md bg-neutral-50 p-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="flex gap-2">
          <Skeleton className="h-5 w-[120px]" />
          <Skeleton className="h-5 w-24" />
        </div>
      ))}
    </div>

    <div className="flex flex-col gap-2">
      <Skeleton className="h-4 w-36" />
      <Skeleton className="h-9 w-full rounded-md" />
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton key={index} className="h-[62px] rounded-[11px]" />
      ))}
    </div>

    <div className="space-y-1.5">
      <Skeleton className="h-4 w-28" />
      <Skeleton className="h-9 w-full rounded-md" />
    </div>
  </>
);

export default MatchExpenseModalSkeleton;
